import styled from "@emotion/styled";
import classNames from "classnames";
import * as React from "react";
import { FieldRenderProps } from "react-final-form";

import { Checkbox, CheckboxFinalForm, IProps as CheckboxProps, ICheckboxCustomProps } from "./Checkbox";

const StyledCheckbox = styled.label`
  display: flex;
  align-items: center;

  .checkbox {
    flex: 0 0 auto;
    display: block;
  }

  & > .label {
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.primaryColor
    };
    user-select: none;
    cursor: pointer;
    display: block;
    padding-left: 8px;
  }

  &.disabled > .label {
    cursor: default;
  }
`;

export const CheckboxWithLabel: React.FC<CheckboxProps & ICheckboxCustomProps> = ({ children, ...rest }) => {
  const { disabled } = rest;

  return (
    <StyledCheckbox className={classNames({ disabled })}>
      <span className="checkbox">
        <Checkbox {...rest} />
      </span>
      {children && <span className="label">{children}</span>}
    </StyledCheckbox>
  );
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface ICheckboxWithLabelFieldProps extends FieldRenderProps<any, HTMLInputElement> {
  className?: string;
}
export const CheckboxWithLabelFinalForm: React.FC<ICheckboxWithLabelFieldProps> = ({
  children,
  className,
  ...rest
}) => (
  <StyledCheckbox className={className}>
    <span className="checkbox">
      {/* @ts-expect-error TS(2322) */}
      <CheckboxFinalForm {...rest} />
    </span>
    {children && <span className="label">{children}</span>}
  </StyledCheckbox>
);
